import AssetsManager from '../assets_management/AssetsManager';
import ParameterErrors from '../errors/ParameterErrors';
import ParseError from '../errors/ParseError';
import Scene360Hotspot from '../360_react/Scene360Hotspot';
import Urls from '../urls/Urls';
import EulerAngles from '../geometry/EulerAngles';
import PlotStatus from '../site/PlotStatus';
const { throwNotProvided, throwNotOfType} = ParameterErrors;
export default class HotspotOutside360Configurator extends Scene360Hotspot{
	constructor(props){
		super(props);
		this._rotateToCompensate = false;
		const {plotNumber, getPlotByNumber,
			configuration}=props;
		this._configuration = configuration;
		if(plotNumber===undefined||plotNumber===null)
			throwNotProvided('plotNumber');
		this._plotNumber = plotNumber;
		if(getPlotByNumber===undefined||getPlotByNumber===null)
			throwNotProvided('getPlotByNumber');
		this._getPlotByNumber = getPlotByNumber;
	}
	get iconRelativePath(){
		const plot = this._getPlotByNumber(this._plotNumber);
		return PlotStatus.getConfiguratorIconRelativePath(plot?.status, this._configuration);
	}
	get fromFactory(){
		return false;
	}
	get plotNumber(){
		return this._plotNumber;
	}
	get className(){
		return 'configurator-hotspot';
	}
	get enabled(){
		const plot = this._getPlotByNumber(this._plotNumber);
		if(plot.affordable===true)return false;
		const url = Urls.getConfiguratorUrlForPlot(plot, this._configuration);
		return this._configuration.showPanelOnClickOutside360ConfiguratorIcon||(url?true:false);
	}
	static fromJSON(jObject, getPlotByNumber, configuration){
		return new HotspotOutside360Configurator({
			iconRelativePath:'override',
			type:jObject.type,
			eulerAngles:EulerAngles.fromJSON(jObject.eulerAngles),
			pointingAtEulerAngles:jObject.pointingAtEulerAngles?EulerAngles.fromJSON(jObject.pointingAtEulerAngles):null,
			plotNumber:jObject.plotNumber,
			getPlotByNumber:getPlotByNumber,
			configuration
		});
	}
}